import {
    REQUEST_ACCOUNT_EBONS,
    RECEIVE_ACCOUNT_EBONS,
    FAILURE_ACCOUNT_EBONS,
    REQUEST_ACCOUNT_EBONS_CODE,
    RECEIVE_ACCOUNT_EBONS_CODE,
    FAILURE_ACCOUNT_EBONS_CODE
} from './constants';
import { CALL_API } from '../../../middlewares/api';
import { HTTP_METHOD_PUT } from '../../../constants/httpMethod';
import _ from 'lodash';

// on va update le store account avec de nouvelles infos membre
export function fetchAccountEbonOrdersIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/ebon/orders',
            types: [REQUEST_ACCOUNT_EBONS, RECEIVE_ACCOUNT_EBONS, FAILURE_ACCOUNT_EBONS],
            shouldCallAPI: state => shouldFetchAccountEbonOrders(state),
            authenticated: true
        }
    };
}

export function fetchAccountEbonOrderByIdWithCode(id) {
    return {
        [CALL_API]: {
            endpoint: `/ebon/order/${id}/code`,
            types: [
                REQUEST_ACCOUNT_EBONS_CODE,
                RECEIVE_ACCOUNT_EBONS_CODE,
                FAILURE_ACCOUNT_EBONS_CODE
            ],
            shouldCallAPI: () => true,
            authenticated: true
        }
    };
}

export function updateEbonUserState(ebonUserStates) {
    return {
        [CALL_API]: {
            endpoint: `/ebon/update-user-state`,
            method: HTTP_METHOD_PUT,
            types: ['UPDATE_EBON_STATUS_REQUEST', 'UPDATE_EBON_STATUS_SUCCESS', 'UPDATE_EBON_STATUS_FAILURE'],
            body: {
                ebonUserStates
            },
            authenticated: true
        }
    };
}

const shouldFetchAccountEbonOrders = state => {
    const ebonOrders = state.account.myebons.ebonOrders;
    const fetching = state.account.fetching;
    if (fetching) {
        return false;
    } else if (_.isEmpty(ebonOrders)) {
        return true;
    } else {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/services/account/ebons/actions.js